<template>
    <div class="estates-carousel-recent" v-show="show">
        <div class="container">
            <h2 class="subtitle">{{ title }}</h2>

            <estates-carousel
                :estates="estates"
                :per-page-custom="perPageCustom"
                
            />
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies'

import Carousel from './Carousel'

export default {
    components: {
        'estates-carousel': Carousel,
    },

    props: {
        title: {
            type: String,
            required: false,
        },

        sector: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            default: 'site',
            validator: function (value) {
                return ["site", "user-area"].includes(value);
            },
        },    

    },

    data() {
        return {
            estates: [],
            show: false,
            
        }
    },

    computed:{
        perPageCustom(){
           return this.type === 'site' 
                ?   [[0, 1], [768, 3], [1440, 4], [1920, 4]]
                : [[0, 1], [768, 2], [1440, 4], [1920, 4]]

        }
    },

    mounted() {
        var recent = JSON.parse($cookies.get('recent_' + this.sector))

        if (recent) {
            axios.get('/api/estates/recent?section=' + this.sector + '&ids=' + recent.join())
                .then(({data}) => {
                    if (data.length) {
                        this.estates = data
                        this.show = true
                    }
                })
        }
    },

}
</script>